export default __webpack_public_path__ + "static/media/SndLowerLDownBumpLine.001ab48c.mp3";